module.exports = __webpack_public_path__ + "img/tank-base-mask-2.8134624e.png";